import {axios} from '../../../lib'

export const getCompanies = () => {
    return axios.get('/companies')
}
